import { Button } from 'primereact/button';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

const PrwcRoundedTextIconButton = (props: any) => {
  const { onClick, labelKey, className = "p-button-rounded p-button-text", color = "p-button-danger", type = "button", icon, tooltipText, tooltipOptions={position: 'bottom'} } = props;
  const { t } = useTranslation();

  return (
    <span className="prw-rounded-text-icon-button">
      <Button
        icon={icon}
        label={t(labelKey)}
        onClick={onClick}
        type={type}
        className={className + " " + color}
        tooltip={tooltipText}
        tooltipOptions={tooltipOptions}
      />
    </span>
  );
};

export default PrwcRoundedTextIconButton;
